// mui
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

const LinkMediaPageButton = () => {
    const handleClick = () => {
        const newTab = window.open("/media", '_blank');
        if (newTab) {
            newTab.focus();
        }
    };

    return (
        <>
            <ButtonGroup
                size="small"
                aria-label="small button group"
            >
                <Button
                    onClick={(event) => {
                        event.preventDefault();
                        handleClick();
                    }}
                    color="primary"
                    sx={{whiteSpace: "nowrap"}}
                >
                    メディア追加
                </Button>
            </ButtonGroup>
        </>
    );
};

export default LinkMediaPageButton;
    